// 出发按钮（EP-004-S4）—— 屏宽 60%、56px 高、圆角 12px。
// home：A3 底 + #FFF8F0 文字，可点「送它出门」。
// away / awaitingReveal：N2 灰态禁用（T6 / 验收 C1）。
import { useGameStore } from '../store';
import { planDeparture, isLocalDevRuntime } from '../core/depart';
import { randomRng } from '../core/rng';

// 演示用：?tripMs=N 可覆盖出发时长（仅验收 / playtest，不暴露给正式玩家，GDD 02 §G3）。
function demoTripMsOverride(): number | null {
  if (typeof window === 'undefined') return null;
  const raw = new URLSearchParams(window.location.search).get('tripMs');
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

const TEXT_BY_PHASE: Record<'home' | 'away' | 'awaitingReveal', string> = {
  home: '送它出门',
  away: '它出门了',
  awaitingReveal: '它回来了',
};

export function DepartButton() {
  const phase = useGameStore((s) => (s.save === null ? 'no-save' : s.save.dogState));
  const save = useGameStore((s) => s.save);
  const depart = useGameStore((s) => s.depart);

  const disabled = phase !== 'home';

  const handleClick = (): void => {
    if (phase !== 'home' || !save) return;
    const rng = randomRng();
    // 本地（localhost + DEV）快测：时长缩到 2 分钟档（首旅 20s / 常规 2min / 长旅 3min）。
    // 生产构建 import.meta.env.DEV 为 false，isLocalDevRuntime() 恒 false，时长一行不变。
    const localDevShorten = isLocalDevRuntime();
    const plan = planDeparture(save, rng, save.settings.timeScale ?? 1, { localDevShorten });
    // 优先级：?tripMs=N 显式覆盖 > localhost 缩短 > 正常时长（显式覆盖仍最高）。
    const durationMs = demoTripMsOverride() ?? plan.travelDurationMs;
    depart(durationMs, plan.destinationId, plan.isLongTrip);
  };

  return (
    <button
      type="button"
      className="depart-button"
      disabled={disabled}
      onClick={handleClick}
      aria-label={TEXT_BY_PHASE[phase === 'no-save' ? 'home' : (phase as 'home' | 'away' | 'awaitingReveal')]}
    >
      {TEXT_BY_PHASE[phase === 'no-save' ? 'home' : (phase as 'home' | 'away' | 'awaitingReveal')]}
    </button>
  );
}
